module.exports = __webpack_public_path__ + "img/pepper.9bf847f2.webp";